import { LegalLayout } from "@/components/legal/LegalLayout";

const OnBilgilendirmeFormuPage = () => (
  <LegalLayout
    title="Ön Bilgilendirme Formu"
    description="Mesafeli satışa konu ürün ve hizmetlere ilişkin ön bilgilendirme metnidir."
    path="/on-bilgilendirme-formu"
  >
    <p>
      İşbu Ön Bilgilendirme Formu, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği
      gereğince tüketicilerin bilgilendirilmesi amacıyla İns Organizasyon Danışmanlık ve Dış Tic. Ltd. Şti. tarafından
      hazırlanmıştır. Web sitemiz üzerinden sunulan saha operasyonu hizmetleri ve bağış paketleri bu form kapsamındadır.
    </p>

    <h2>1. Satıcıya İlişkin Bilgiler</h2>
    <ul>
      <li><strong>Unvan:</strong> İns Organizasyon Danışmanlık ve Dış Tic. Ltd. Şti.</li>
      <li><strong>Adres:</strong> Çamlıca Mah. 168. Cad. No: 3 Yenimahalle / Ankara</li>
      <li><strong>Telefon:</strong> +90 541 587 88 22</li>
      <li><strong>E-posta:</strong> info@insorganizasyon.org</li>
    </ul>

    <h2>2. Ürün ve Hizmetlerin Temel Özellikleri</h2>
    <p>
      Web sitemizde satın alınabilen tüm saha operasyonu paketlerinde; operasyon içeriği, kapsadığı ülke ve teslim süreci
      ilgili sayfalarda ayrıntılı olarak belirtilmiştir. Sunulan hizmetler bire bir fiziksel ürün değil, sahanın ihtiyaçlarına
      yönelik profesyonel operasyon yönetimidir.
    </p>

    <h2>3. Fiyatlandırma ve Ödeme Koşulları</h2>
    <ul>
      <li>Fiyatlara KDV dâhil olup, bağış paketlerinde ilgili alan belirtildiği üzere operasyon maliyetleri yer almaktadır.</li>
      <li>Ödemeler banka/kredi kartı, havale/EFT veya anlaşmalı ödeme kuruluşları üzerinden yapılabilir.</li>
      <li>Ödeme tamamlandığında işletim süreci başlamakta olup, dijital makbuz e-posta yoluyla iletilmektedir.</li>
    </ul>

    <h2>4. İfa Süresi</h2>
    <p>
      Operasyonun gerçekleştirileceği ülke ve proje türüne göre teslim süresi değişmekle birlikte, her proje sayfasında
      öngörülen tamamlanma takvimi paylaşılmaktadır. Operasyon takibi, bağışçı paneli veya e-posta bildirimi ile yapılır.
    </p>

    <h2>5. Cayma Hakkı</h2>
    <p>
      Hizmetin ifasına başlanmamış olması şartıyla tüketicinin 14 gün içerisinde cayma hakkı bulunmaktadır. Cayma hakkının
      kullanılması durumunda <a href="/iptal-iade-kosullari">İptal ve İade Koşulları</a> geçerlidir. Saha operasyonuna başlanmış
      olması veya üçüncü kişiler için ifanın tamamlanması halinde cayma hakkı sınırlandırılabilir.
    </p>

    <h2>6. İtiraz ve Şikâyet</h2>
    <p>
      Tüketici şikâyet ve itirazları, aşağıda yer alan iletişim kanalları veya İlgili Tüketici Hakem Heyetleri / Mahkemeleri
      aracılığıyla iletilebilir.
    </p>

    <ul>
      <li><strong>E-posta:</strong> info@insorganizasyon.org</li>
      <li><strong>Telefon:</strong> +90 541 587 88 22</li>
      <li><strong>Adres:</strong> Arabacıalanı Mah. Çark Cad. No: 236 Daire 2 Serdivan / Sakarya</li>
    </ul>

    <p>
      İşbu form elektronik ortamda onaylanmakta olup, mesafeli satış sözleşmesinin ayrılmaz parçasıdır.
    </p>
  </LegalLayout>
);

export default OnBilgilendirmeFormuPage;
